/**
 * Public absolute origin for metadata, sitemap, robots, JSON-LD, and share URLs.
 * Set `NEXT_PUBLIC_SITE_URL` in production (`https://www.progsity.io` on Vercel).
 *
 * `www.progsity.io` is the canonical public host (`docs/08` Domains): the bare
 * apex answers every request with a 307 to it. An env value naming the apex
 * therefore put a redirecting URL into every canonical link, every hreflang
 * pair, every sitemap entry and the robots directive, which is what production
 * served until 2026-09-03. `canonicalSiteUrl` folds the apex into `www` so the
 * build cannot publish that again; the env should still say `www`.
 */

const APEX_HOST = "progsity.io";

export function canonicalSiteUrl(raw: string | undefined): string {
  const value = raw && raw.trim().length > 0 ? raw.trim() : "http://localhost:3000";
  try {
    const url = new URL(value);
    if (url.hostname === APEX_HOST) url.hostname = `www.${APEX_HOST}`;
    return url.origin;
  } catch {
    return value.replace(/\/$/, "");
  }
}

export const SITE_URL = canonicalSiteUrl(process.env.NEXT_PUBLIC_SITE_URL);
